import { Grid } from '@mui/material'
import React from 'react'
import { CardItem } from './CardItem'

export const CardsContainer = () => {
  return (
    <Grid container spacing={2} sx={{width: '100%'}}>
        <CardItem />
    </Grid>
  )
}
